module.exports = __webpack_public_path__ + "static/NOI5-3048c3c8d055ad857c01e6a4901ec0bf.jpg";